<div class="min-h-screen bg-gray-50 flex flex-col">
  <tt-header
    [logoUrl]="logoUrl"
    [title]="''"
    [languages]="languages"
    [activeLang]="currentLanguage"
    [backgroundColor]="'#ffffff'"
    [showLogout]="false"
    (langChange)="onLangChange($event)"
  />
  <main class="flex-1">
    <router-outlet />
  </main>
</div>
